/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type VideoVisitEndedPayloadSideEffectType =
  (typeof VideoVisitEndedPayloadSideEffectType)[keyof typeof VideoVisitEndedPayloadSideEffectType];

export const VideoVisitEndedPayloadSideEffectType = {
  video_visit_ended: "video_visit_ended",
} as const;
